import React, {useEffect, useState, useContext} from "react";
import { useHistory } from "react-router-dom";
import http from '../../../../../services/api/utilities/http';
import styles from "./uploadProgress/UploadProgress.module.scss";
import Button from "../../../../Componnets/Button/Button";
import appContext from "../../../../../context/appContext";

const UploadProgress = ({ handlePreviousStep, selectedFile, handleSetRefresh, handleTriggerShowModal, fileName }) => {

  const context = useContext(appContext);
  const [progressWidth, setProgressWidth] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('uploading');
  const [file, setFile] = useState(null);

  const history = useHistory();

  useEffect(() => {
    const formData = new FormData();
    formData.append(
      'file',
      selectedFile,
    );
    formData.append('name', fileName);
    setFile(formData);
  }, [selectedFile]);

  let analysisId = null;
  if (context.handleUid().id) {
    analysisId = context.handleUid().id;
  } else {
    analysisId = JSON.parse(localStorage.getItem("mapData")).id;
  }

  useEffect(() => {
    if (file) {

      const onUploadProgress = progressEvent => {
        setProgressWidth(Math.round((progressEvent.loaded * 100) / progressEvent.total))
      };

      http({
        method: 'put',
        url: `process_mining/bpmn/${analysisId}`,
        data: file,
        headers: {Authorization: 'Bearer ' + localStorage.getItem('token')},
        onUploadProgress
      })
        .then(res => {
          setUploadStatus('success')
          // setFileUrl(`/show-bpmn?url=${res.data.data.file}`);
      })
        .catch(err => {
          console.log(err)
        })
    }
  }, [file])

  const handleOnContinue = () => {
    history.push('/bpmn-models');
    handleSetRefresh();
    handleTriggerShowModal();
    // history.push(fileUrl);
  }

  return (
    <div className={styles.UploadProgress}>
      <div className={styles.progressBarWrapper}>
        <div className={[styles.infos, uploadStatus === 'uploading' ? styles.uploading : styles.success, 'd-flex'].join(' ')}>
          <div>
            <div className={styles.fileName}>
              {uploadStatus === 'uploading' && fileName && <span>Uploading { fileName } ...</span>}
              {uploadStatus !== 'uploading' && fileName && <span>{ fileName }</span>}
            </div>
            <div className={styles.status}>
              {
                uploadStatus === 'uploading' && <span><span>{progressWidth}%</span></span>
              }
              {uploadStatus === 'success' && <span>Completed</span>}
              {uploadStatus === 'failed' && <span className={styles.textRed}>Failed</span>}
            </div>
          </div>
          {
            <div className={[styles.infoIcon, 'd-flex align-items-center'].join(' ')}>
              {
                uploadStatus === 'success' && (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.2" d="M14.3405 -0.000183105H5.67049C2.28049 -0.000183105 0.000488281 2.37982 0.000488281 5.91982V14.0898C0.000488281 17.6198 2.28049 19.9998 5.67049 19.9998H14.3405C17.7305 19.9998 20.0005 17.6198 20.0005 14.0898V5.91982C20.0005 2.37982 17.7305 -0.000183105 14.3405 -0.000183105Z" fill="#02FCC1"/>
                    <path d="M8.81344 13.2479C8.58944 13.2479 8.36544 13.1629 8.19444 12.9919L5.82144 10.6189C5.47944 10.2769 5.47944 9.7229 5.82144 9.3819C6.16344 9.0399 6.71644 9.0389 7.05844 9.3809L8.81344 11.1359L12.9414 7.0079C13.2834 6.6659 13.8364 6.6659 14.1784 7.0079C14.5204 7.3499 14.5204 7.9039 14.1784 8.2459L9.43244 12.9919C9.26144 13.1629 9.03744 13.2479 8.81344 13.2479Z" fill="#02FCC1"/>
                  </svg>
                )
              }
              {
                uploadStatus === 'failed' && (
                  <div className={'d-flex align-items-center'}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.2" d="M14.6667 0H5.33333C1.92889 0 0 1.92889 0 5.33333V14.6667C0 18.0622 1.92 20 5.33333 20H14.6667C18.0711 20 20 18.0622 20 14.6667V5.33333C20 1.92889 18.0711 0 14.6667 0Z" fill="#FF0053"/>
                      <path d="M12.8489 8.15295L11.031 9.97088L12.8331 11.773C13.1233 12.0632 13.1212 12.5357 12.8285 12.8284C12.5358 13.1211 12.0633 13.1232 11.7732 12.833L9.97099 11.0309L8.15307 12.8488C7.85201 13.0938 7.41645 13.0732 7.14434 12.8011C6.87223 12.529 6.85163 12.0934 7.09663 11.7923L8.90886 9.98012L7.11234 8.18361C6.86996 7.88467 6.89435 7.44891 7.16884 7.17442C7.44333 6.89993 7.87909 6.87554 8.17802 7.11793L9.97454 8.91444L11.7925 7.09651C12.0935 6.85151 12.5291 6.87211 12.8012 7.14422C13.0733 7.41633 13.0939 7.8519 12.8489 8.15295Z" fill="#FF0053"/>
                    </svg>
                    <span className={[styles.textRed, 'ml-2'].join(' ')}>Wrong File Format</span>
                  </div>
                )
              }
            </div>
          }
        </div>
        <div className={styles.rightButtons}>
          {
            uploadStatus === 'uploading' && (
              <div className={[styles.abortUpload, 'd-flex justify-content-center align-items-center'].join(' ')}>
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.01582 5.77032L5.23682 3.99232L7.01482 2.21432C7.35682 1.87332 7.35682 1.31832 7.01482 0.977317C6.67282 0.633317 6.11982 0.634317 5.77782 0.976317L3.99882 2.75432L2.21982 0.974317C1.87782 0.632317 1.32382 0.634317 0.981824 0.974317C0.640824 1.31632 0.640824 1.87132 0.981824 2.21232L2.76182 3.99232L0.985824 5.76732C0.643824 6.10932 0.643824 6.66432 0.985824 7.00432C1.15682 7.17632 1.37982 7.26132 1.60382 7.26132C1.82882 7.26132 2.05182 7.17632 2.22282 7.00532L3.99882 5.22932L5.77882 7.00832C5.94982 7.17932 6.17282 7.26432 6.39682 7.26432C6.62082 7.26432 6.84482 7.17832 7.01582 7.00832C7.35782 6.66632 7.35782 6.11232 7.01582 5.77032Z" fill="#FF0053"/>
                </svg>
              </div>
            )
          }
          {
            uploadStatus === 'success' && (
              <div className={'d-flex justify-content-center align-items-center'}>
                {/*<div style={{width: 97}} className={'mr-3'}>*/}
                {/*  <Button block type={'outline'} title={'Rename'} />*/}
                {/*</div>*/}
                <div style={{width: 97}}>
                  <Button block onClick={handleOnContinue} title={'Continue'}/>
                </div>
                <svg className={[styles.pointer, 'ml-4'].join(' ')} width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.3248 7.4682C16.3248 7.4682 15.7818 14.2032 15.4668 17.0402C15.3168 18.3952 14.4798 19.1892 13.1088 19.2142C10.4998 19.2612 7.88779 19.2642 5.27979 19.2092C3.96079 19.1822 3.13779 18.3782 2.99079 17.0472C2.67379 14.1852 2.13379 7.4682 2.13379 7.4682" stroke="#FF0053" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M17.708 4.23969H0.75" stroke="#FF0053" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14.4406 4.23967C13.6556 4.23967 12.9796 3.68467 12.8256 2.91567L12.5826 1.69967C12.4326 1.13867 11.9246 0.750671 11.3456 0.750671H7.11258C6.53358 0.750671 6.02558 1.13867 5.87558 1.69967L5.63258 2.91567C5.47858 3.68467 4.80258 4.23967 4.01758 4.23967" stroke="#FF0053" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            )
          }
          {
            uploadStatus === 'failed' && (
              <div className={[styles.pointer, 'd-flex justify-content-center align-items-center'].join(' ')}>
                <Button onClick={handlePreviousStep} title={'Back'}/>
              </div>
            )
          }
        </div>
        {uploadStatus === 'uploading' && <span style={{width: `${progressWidth}%`}}></span>}
      </div>
    </div>
  )
};

export default UploadProgress;
